import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import AgriSubContract from '@/models/AgriSubContract.js'

export const useAgriSubContractStore = defineStore('agriSubContractStore', () => {
  let syncableModel = useSyncableModel(useApiResource('agri_sub_contracts'), {
    className: AgriSubContract.modelName.name,
    paramKey: AgriSubContract.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
